import React, { forwardRef } from "react"
import type { SelectProps } from "./types"
import { Error, Helper, Label } from "../styles"
import { SelectWrapper, Styledselect, Wrapper } from "./styles"

const Select = forwardRef<HTMLSelectElement, SelectProps>(({
    id,
    label,
    options,
    error,
    helperText,
    css,
    placeholder,
    selectedOption,
    ...props
}, ref) => {
    return <SelectWrapper css={css}>
        {label && <Label htmlFor={id} css={{ ml: 10 }}>{label}</Label>}

        <Wrapper>
            <Styledselect
                ref={ref}
                id={id}
                {...props}
            >
                {placeholder && <option value="">{placeholder}</option>}
                {options?.map((option) => (
                    <option
                        key={`key_${option.value}`}
                        value={option.value}
                        defaultValue={selectedOption?.value === option.value}
                    >
                        {option.label}
                    </option>
                ))}
            </Styledselect>
        </Wrapper>

        {error && <Error>{error}</Error>}
        {helperText && <Helper>{helperText}</Helper>}
    </SelectWrapper>
})

export default Select
